/* Diva: wait 300 ms before a desktop dropdown opens, so it does not flash open when the mouse only passes
   over the menu (Baymard: 300 to 500 ms hover delay). Once a dropdown is open, moving to the next menu item
   switches straight away. The theme's own menu code is untouched: this holds back the first mouseenter and
   re-sends it if the pointer is still on the item. */
(function () {
  var DELAY = 300;
  var timer = null;
  var lastOpenLeft = 0;
  var desktop = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('mouseenter', function (event) {
    var item = event.target;
    if (!(item instanceof Element) || item.tagName !== 'HOVER-DISCLOSURE' || event.divaDelayed || !desktop.matches) return;
    // The theme closes the old dropdown just before the pointer reaches the next item, so "a dropdown was open a moment ago" counts as open
    if (document.querySelector('hover-disclosure.is-visible') || Date.now() - lastOpenLeft < DELAY) return;
    event.stopImmediatePropagation();
    event.stopPropagation();
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!item.matches(':hover')) return;
      var replay = new Event('mouseenter');
      replay.divaDelayed = true;
      item.dispatchEvent(replay);
    }, DELAY);
  }, true);

  document.addEventListener('mouseleave', function (event) {
    if (!(event.target instanceof Element) || event.target.tagName !== 'HOVER-DISCLOSURE') return;
    clearTimeout(timer);
    if (event.target.classList.contains('is-visible')) lastOpenLeft = Date.now();
  }, true);
})();

/* Diva: in the phone menu, a group heading that only links to "#" (By Material, By Style, By Celebration)
   opens its group when tapped, the same as the "+" beside it, instead of doing nothing */
document.addEventListener('click', function (event) {
  var link = event.target instanceof Element && event.target.closest('a.mobile-navlink--level-2[href="#"]');
  if (!link) return;
  var trigger = link.parentNode.querySelector('[data-collapsible-trigger]');
  if (!trigger) return;
  event.preventDefault();
  trigger.dispatchEvent(new Event('click', { bubbles: true }));
});

